const swiper = new Swiper('.brands-swiper', {
	slidesPerView: 2,
  speed: 6000,
	loop: true,
	autoplay: {
		delay: 1,
		disableOnInteraction: false
	},
	freeMode: true,
	freeModeMomentum: false,
	breakpoints: {
		768: {
			slidesPerView: 3,
		},
		1024: {
			slidesPerView: 4,
		},
		1200: {
			slidesPerView: 5,
		},
		1920: {
			slidesPerView: 6,
		},

	}
});

const annoucementsSwiper = new Swiper('.announcements-swiper', {
	slidesPerView: 1.6,
	loop: false,
	spaceBetween: 15,
	breakpoints: {
		768: {
			slidesPerView: 2,
		}, 
		1024: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	},
	navigation: {
		nextEl: ".announcements-swiper-next",
		prevEl: ".announcements-swiper-prev",
	},
	pagination: {
		el: ".announcements-swiper-pagination",
		clickable: true,
	},
});

const offerSwiper = new Swiper('.offer-swiper', {
	slidesPerView: 1,
	loop: true,
	spaceBetween: 0,
	autoplay: {
		delay: 5000,
		disableOnInteraction: true,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

const aktuelltSwiper = new Swiper('.aktuellt-swiper', {
	slidesPerView: 1,
	loop: true,
	spaceBetween: 30,
	breakpoints: {
		1024: {
			slidesPerView: 'auto',
		},
	},
	navigation: {
		nextEl: ".aktuellt-swiper-next",
		prevEl: ".aktuellt-swiper-prev",
	},
	pagination: {
		el: ".aktuellt-swiper-pagination",
		clickable: true,
	},
});

const avdelningSwiper = new Swiper('.avdelning-swiper', {
	slidesPerView: 2.15,
	spaceBetween: 15,
	initialSlide: 1,

	loopedSlides: 2,
	slidesPerGroup: 1,
	loop: true,


	breakpoints: {
		1024: {
			slidesPerView: 4,
				spaceBetween: 30,
		},
	},
	navigation: {
		nextEl: ".avdelning-swiper-next",
		prevEl: ".avdelning-swiper-prev",
	},
	pagination: {
		el: ".avdelning-swiper-pagination",
		 type: "progressbar",
		clickable: true,
	},
	// prepend to additional slides that loop will use	loopedSlides: 
});


